import initMainVisualSlider from '../modules/initMainVisualSlider'
import addClickTabEvent from '../modules/addClickTabEvent'

addClickTabEvent()
window.addEventListener('DOMContentLoaded', initMainVisualSlider, false)
